import React from 'react'
import Pagination from '@material-ui/lab/Pagination';

const CustomePagination = (props: any) => {
  return (
    <div className='w-100 mt-4 d-flex justify-content-center'>
      <Pagination
        onChange={props.onPageChange}
        boundaryCount={0}
        count={props.count}
        variant="outlined"
        shape="rounded"
        dir='ltr'
      />
    </div>
  )
}

export default CustomePagination